import {
	BrowserWindow,
	BrowserWindowSymbol,
	Experiments,
	ExperimentsSymbol,
	EditorFeatureConfigSymbol,
	IAppDidMountHandler,
} from '@wix/thunderbolt-symbols'
import { accessibilityUtils } from '../accessibilityUtils'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { AccessibilityEditorConfig, AccessibilitySideEffects } from '../types'
import { name } from '../symbols'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'

const dsAccessibility = (
	editorConfig: AccessibilityEditorConfig,
	window: BrowserWindow,
	experiments: Experiments
): IAppDidMountHandler & IModelUpdatesHandlersImplementor<AccessibilitySideEffects> => {
	const { addFocusRingAndKeyboardTabbingOnClasses, removeKeyboardTabbingOnClass } = accessibilityUtils(
		window,
		experiments
	)

	const addListeners = (visualFocusEnabled: boolean) => {
		if (visualFocusEnabled) {
			window!.addEventListener('keydown', addFocusRingAndKeyboardTabbingOnClasses)
			window!.addEventListener('click', removeKeyboardTabbingOnClass)
		}
	}

	return {
		appDidMount() {
			addListeners(editorConfig.visualFocusEnabled)
		},
		featureName: name,
		handlers: { onDsAccessibilityUpdate: addListeners },
	}
}

export const DsAccessibility = withDependencies(
	[named(EditorFeatureConfigSymbol, name), BrowserWindowSymbol, ExperimentsSymbol],
	dsAccessibility
)
